// import { useNavigate } from "react-router-dom"; // Import useNavigate
// import React, { useEffect, useState } from "react";
// import "./Home.css";
// import img1 from "../../Assets/BackgroundImage1.png"; // Replace with actual images
// import img2 from "../../Assets/BackgroundImage3.png";
// import img3 from "../../Assets/BackgroundImage2.png";
// import img4 from "../../Assets/BackgroundImage4.png";
// import NavigationBar from "../../Components/NavigationBar";
// import BookText  from "lucide-react"; // Import BookText component


// const HomePage = () => {
//   const navigate = useNavigate();
//   const [applicationDates, setApplicationDates] = useState(null);
//   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

//   const handleLogin = () => navigate("/login");
//   const handleSignup = () => navigate("/signup");

//   useEffect(() => {
//     const fetchDates = async () => {
//       try {
//         const res = await fetch(`${API_BASE_URL}/getApplicationDates`);
//         const result = await res.json();
//         if (result.status === 'success') {
//           setApplicationDates(result.data);
//         }
//       } catch (err) {
//         console.error('Error fetching dates:', err);
//       }
//     };
//     fetchDates();
//   }, [API_BASE_URL]);


//   return (
//     <div>
//       <NavigationBar />
//       <div className="homepage">
//         {/* Hero Section */}
//         <section className="hero">
//           <div className="titlebox">
//             <h2 className="hero-title">
//               Empowering Excellence in Awards and Recognition
//             </h2>
//             <p className="hero-subtitle">
//               A streamlined platform for managing awards, simplifying applications, and celebrating achievements!
//             </p>
//           </div>

//           {/* Circular Images Section */}
//           <div className="circle-images">
//             <div className="circle large">
//               <img src={img1} alt="Discussion" />
//             </div>
//             <div className="circle small">
//               <img src={img3} alt="Tablet" />
//             </div>
//             <div className="circle medium">
//               <img src={img2} alt="Learning" />
//             </div>
//             <div className="circle large">
//               <img src={img4} alt="Online Meeting" />
//             </div>
//           </div>

//           {/* Signup and Login Buttons Section */}
//           <div className="auth-buttons">
//             <button className="btn signup-btn" onClick={handleSignup}>Sign Up</button>
//             <button className="btn login-btn" onClick={handleLogin}>Login</button> {/* Add onClick handler */}
//           </div>
//         </section>

//           {/* <section className="dates">
//           <div className="dates-box">
//             <div className="dates-content">
//               <div className="date-item">
//                 <span className="date-label">📅 Application Open Date:</span>
//                 <span>
//                   {applicationDates
//                     ? `${applicationDates.Start_Date} at ${applicationDates.Start_Time}`
//                     : "Loading..."}
//                 </span>
//               </div>
//               <div className="date-item">
//                 <span className="date-label">📆 Application Close Date:</span>
//                 <span>
//                   {applicationDates
//                     ? `${applicationDates.End_Date} at ${applicationDates.End_Time}`
//                     : "Loading..."}
//                 </span>
//               </div>
//             </div>
//           </div>
//         </section> */}

//         {/* Partners Section */}
//         <section className="partners">
//           <div className="partner-logos">
//             <span>Application Guidelines</span>
//           </div>
//         </section>

//         {/* Courses Section */}
//         <section className="courses">
//           <h2>Guidelines Details</h2>
//         </section>
//       </div>
//     </div>
//   );
// };

// export default HomePage;


// import { useNavigate } from "react-router-dom";
// import React, { useEffect, useState } from "react";
// import "./Home.css";
// import img1 from "../../Assets/BackgroundImage1.png";
// import img2 from "../../Assets/BackgroundImage3.png";
// import img3 from "../../Assets/BackgroundImage2.png";
// import img4 from "../../Assets/BackgroundImage4.png";
// import NavigationBar from "../../Components/NavigationBar";
// import { Award, CheckCircle, FileText, Star } from "lucide-react";

// const HomePage = () => {
//   const navigate = useNavigate();
//   //const [applicationDates, setApplicationDates] = useState(null);
//   //const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

//   const handleLogin = () => navigate("/login");
//   const handleSignup = () => navigate("/signup");

//   // useEffect(() => {
//   //   const fetchDates = async () => {
//   //     try {
//   //       const res = await fetch(`${API_BASE_URL}/getApplicationDates`);
//   //       const result = await res.json();
//   //       if (result.status === 'success') {
//   //         setApplicationDates(result.data);
//   //       }
//   //     } catch (err) {
//   //       console.error('Error fetching dates:', err);
//   //     }
//   //   };
//   //   fetchDates();
//   // }, [API_BASE_URL]);

//   return (
//     <div>
//       <NavigationBar />
//       <div className="homepage">
//         {/* Hero Section */}
//         <section className="hero">
//           <div className="titlebox">
//             <h2 className="hero-title">
//               Empowering Excellence in Awards and Recognition
//             </h2>
//             <p className="hero-subtitle">
//               A streamlined platform for managing awards, simplifying applications, and celebrating achievements!
//             </p>
//           </div>

//           {/* Circular Images Section */}
//           <div className="circle-images">
//             <div className="circle large">
//               <img src={img1} alt="Discussion" />
//             </div>
//             <div className="circle small">
//               <img src={img3} alt="Tablet" />
//             </div>
//             <div className="circle medium">
//               <img src={img2} alt="Learning" />
//             </div>
//             <div className="circle large">
//               <img src={img4} alt="Online Meeting" />
//             </div>
//           </div>

//           {/* Signup and Login Buttons Section */}
//           <div className="auth-buttons">
//             <button className="btn signup-btn" onClick={handleSignup}>Sign Up</button>
//             <button className="btn login-btn" onClick={handleLogin}>Login</button>
//           </div>
//         </section>

//         {/* Why Apply Section */}
//         <section className="why-apply">
//           <h2 className="section-title">Why Apply for Awards?</h2>
//           <p className="section-subtitle">
//             Discover the benefits of applying for awards through the University Research Council.
//           </p>
//           <div className="benefits-grid">
//             <div className="benefit-item">
//               <Star className="benefit-icon" />
//               <h3>Recognition</h3>
//               <p>Gain prestigious recognition for your outstanding research contributions within and beyond the University of Peradeniya.</p>
//             </div>
//             <div className="benefit-item">
//               <Award className="benefit-icon" />
//               <h3>Funding Support</h3>
//               <p>Access financial assistance for publications and research projects to amplify your work’s impact.</p>
//             </div>
//             {/* <div className="benefit-item">
//               <CheckCircle className="benefit-icon" />
//               <h3>Career Advancement</h3>
//               <p>Boost your academic profile and open doors to new opportunities through URC’s esteemed awards.</p>
//             </div> */}
//           </div>
//         </section>

//         {/* How It Works Section */}
//         <section className="how-it-works">
//           <h2 className="section-title">How It Works</h2>
//           <p className="section-subtitle">
//             Applying for awards is simple and straightforward. Follow these steps to get started.
//           </p>
//           <div className="steps-grid">
//             <div className="step-item">
//               <div className="step-number">1</div>
//               <FileText className="step-icon" />
//               <h3>Download Template</h3>
//               <p>Access the appropriate application template for your chosen award after login to our platform.</p>
//             </div>
//             <div className="step-item">
//               <div className="step-number">2</div>
//               <FileText className="step-icon" />
//               <h3>Complete Application</h3>
//               <p>Fill out the form with your details and attach required documents as a single PDF.</p>
//             </div>
//             <div className="step-item">
//               <div className="step-number">3</div>
//               <CheckCircle className="step-icon" />
//               <h3>Submit & Track</h3>
//               <p>Upload your application through our portal and track its status until the results are announced.</p>
//             </div>
//           </div>
//         </section>
//       </div>
//     </div>
//   );
// };

// export default HomePage;

// import { useNavigate } from "react-router-dom";
// import React from "react";
// import "./Home.css";
// import img1 from "../../Assets/BackgroundImage1.png";
// import img2 from "../../Assets/BackgroundImage3.png";
// import img3 from "../../Assets/BackgroundImage2.png";
// import img4 from "../../Assets/BackgroundImage4.png";
// import NavigationBar from "../../Components/NavigationBar";
// import { Award, CheckCircle, FileText, Star } from "lucide-react";

// const HomePage = () => {
//   const navigate = useNavigate();

//   const handleLogin = () => navigate("/login");
//   const handleSignup = () => navigate("/signup");

//   return (
//     <div>
//       <NavigationBar />
//       <div className="homepage">
//         {/* Hero Section */}
//         <section className="hero">
//           <div className="titlebox">
//             <h2 className="hero-title">
//               Empowering Excellence in Awards and Recognition
//             </h2>
//             <p className="hero-subtitle">
//               A streamlined platform for managing awards, simplifying applications, and celebrating achievements!
//             </p>
//           </div>

//           {/* Circular Images Section */}
//           <div className="circle-images">
//             <div className="circle large">
//               <img src={img1} alt="Discussion" />
//             </div>
//             <div className="circle small">
//               <img src={img3} alt="Tablet" />
//             </div>
//             <div className="circle medium">
//               <img src={img2} alt="Learning" />
//             </div>
//             <div className="circle large">
//               <img src={img4} alt="Online Meeting" />
//             </div>
//           </div>

//           {/* Signup and Login Buttons Section */}
//           <div className="auth-buttons">
//             <button className="btn signup-btn" onClick={handleSignup}>Sign Up</button>
//             <button className="btn login-btn" onClick={handleLogin}>Login</button>
//           </div>
//         </section>

//         {/* Why Apply Section */}
//         <section className="why-apply">
//           <h2 className="section-title">Why Apply for Awards?</h2>
//           <p className="section-subtitle">
//             Discover the benefits of applying for awards through the University Research Council.
//           </p>
//           <div className="benefits-grid">
//             <div className="benefit-item">
//               <Star className="benefit-icon" />
//               <h3>Recognition</h3>
//               <p>Gain prestigious recognition for your outstanding research contributions within and beyond the University of Peradeniya.</p>
//             </div>
//             <div className="benefit-item">
//               <Award className="benefit-icon" />
//               <h3>Funding Support</h3>
//               <p>Access financial assistance for publications and research projects to amplify your work’s impact.</p>
//             </div>
//           </div>
//         </section>

//         {/* Awards Type*/}
//         <section className="why-apply">
//           <h2 className="section-title">Awards</h2>
//           <p className="section-subtitle">
//             Discover the benefits of applying for awards through the University Research Council.
//           </p>
//           <div className="benefits-grid">
//             <div className="benefit-item">
//               <Star className="benefit-icon" />
//               <h3>Research Excellence Awards (Tier 4*)</h3>
//               <p>Gain prestigious recognition for your outstanding research contributions within and beyond the University of Peradeniya.</p>
//             </div>
//             <div className="benefit-item">
//               <Award className="benefit-icon" />
//               <h3>URC Research Awards</h3>
//               <p>Access financial assistance for publications and research projects to amplify your work’s impact.</p>
//             </div>
//              <div className="benefit-item">
//               <Award className="benefit-icon" />
//               <h3>Recognition Awards</h3>
//               <p>Access financial assistance for publications and research projects to amplify your work’s impact.</p>
//             </div>
//             <div className="benefit-item">
//               <Award className="benefit-icon" />
//               <h3>Prof. Lakshman Samaranayake Awards</h3>
//               <p>Access financial assistance for publications and research projects to amplify your work’s impact.</p>
//             </div>
//             <div className="benefit-item">
//               <Award className="benefit-icon" />
//               <h3>Research Publication Facilitation Fund (APC)</h3>
//               <p>Access financial assistance for publications and research projects to amplify your work’s impact.</p>
//             </div>
           
//           </div>
//         </section>

//         {/* How It Works Section */}
//         <section className="how-it-works">
//           <h2 className="section-title">How It Works</h2>
//           <p className="section-subtitle">
//             Applying for awards is simple and straightforward. Follow these steps to get started.
//           </p>
//           <div className="steps-grid">
//             <div className="step-item">
//               <div className="step-number">1</div>
//               <FileText className="step-icon" />
//               <h3>Download Template</h3>
//               <p>Access the appropriate application template for your chosen award after login to our platform.</p>
//             </div>
//             <div className="step-item">
//               <div className="step-number">2</div>
//               <FileText className="step-icon" />
//               <h3>Complete Application</h3>
//               <p>Fill out the form with your details and attach required documents as a single PDF.</p>
//             </div>
//             <div className="step-item">
//               <div className="step-number">3</div>
//               <CheckCircle className="step-icon" />
//               <h3>Submit & Track</h3>
//               <p>Upload your application through our portal and track its status until the results are announced.</p>
//             </div>
//           </div>
//         </section>
//       </div>
//     </div>
//   );
// };

// export default HomePage;

import { useNavigate } from "react-router-dom";
import React from "react";
import "./Home.css";
import img1 from "../../Assets/BackgroundImage1.png";
import img2 from "../../Assets/BackgroundImage3.png";
import img3 from "../../Assets/BackgroundImage2.png";
import img4 from "../../Assets/BackgroundImage4.png";
import NavigationBar from "../../Components/NavigationBar";
import { Award, CheckCircle, FileText, Star, Info } from "lucide-react";

const HomePage = () => {
  const navigate = useNavigate();
  const handleLogin = () => navigate("/login");
  const handleSignup = () => navigate("/signup");
  const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL;
  const handleDownload = (filePath) => {
    window.open(
      `${FILE_BASE_URL}/api/Uploads/ApplicationTemplates/${filePath}`,
      "_blank"
    );
  };
  const handleDownloadCriteria = (filePath1, type) => {
    window.open(`${FILE_BASE_URL}/api/Uploads/ApplicationCriteria/${filePath1}`, "_blank");
  };

  return (
    <div>
      <NavigationBar />
      <div className="homepage">
        {/* Hero Section */}
        <section className="hero">
          <div className="titlebox">
            <h2 className="hero-title">
              Empowering Excellence in Awards and Recognition
            </h2>
            <p className="hero-subtitle">
              A streamlined platform for managing awards, simplifying applications, and celebrating achievements!
            </p>
          </div>

          {/* Circular Images Section */}
          <div className="circle-images">
            <div className="circle large">
              <img src={img1} alt="Discussion" />
            </div>
            <div className="circle small">
              <img src={img3} alt="Tablet" />
            </div>
            <div className="circle medium">
              <img src={img2} alt="Learning" />
            </div>
            <div className="circle large">
              <img src={img4} alt="Online Meeting" />
            </div>
          </div>

          {/* Signup and Login Buttons Section */}
          <div className="auth-buttons">
            <button className="btn signup-btn" onClick={handleSignup}>Sign Up</button>
            <button className="btn login-btn" onClick={handleLogin}>Login</button>
          </div>
        </section>

        {/* Why Apply Section */}
        <section className="why-apply">
          <h2 className="section-title">Why Apply for Awards?</h2>
          <p className="section-subtitle">
            Discover the benefits of applying for awards through the University Research Council.
          </p>
          <div className="benefits-grid">
            <div className="benefit-item">
              <Star className="benefit-icon" />
              <h3>Recognition</h3>
              <p>Gain prestigious recognition for your outstanding research contributions within and beyond the University of Peradeniya.</p>
            </div>
            <div className="benefit-item">
              <Award className="benefit-icon" />
              <h3>Funding Support</h3>
              <p>Access financial assistance for publications and research projects to amplify your work’s impact.</p>
            </div>
          </div>
        </section>

        {/* Excellence Awards Section */}
        <section className="excellence-awards">
          <h2 className="section-title">Awards We Offer</h2>
          <div className="awards-zigzag">
            <div className="award-item left">
              <h3 className="award-title">Research Excellence Awards (Tier 4*)</h3>
              <div className="award-box">
                <Star className="award-icon" />
                <p>Recognizes permanent academic and administrative staff with high h-index values across disciplines, based on UGC Circular 05/2018 criteria.</p>
                <div className="award-actions">
                  <span
  className="more-details"
  onClick={() => handleDownloadCriteria("Research_Excellence_Award_(Tier4)_criteria.pdf")}
  style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
>
  <Info className="info-icon" style={{ marginRight: "5px" }} />
  More Details
</span>

                  <div className="download-group">
                    <label>Application Template: </label>
                      <button
              className="download-btn"
              onClick={() => handleDownload("Research_Excellence_Award_(Tier4).pdf")}
            >
              Download
            </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="award-item right">
              <h3 className="award-title">URC Research Awards</h3>
              <div className="award-box">
                <Award className="award-icon" />
                <p>Honors outstanding researchers (by rank) for recent publications, patents, and grants, with awards presented at PURSE/iPURSE events.</p>
                <div className="award-actions">
                   <span
  className="more-details"
  onClick={() => handleDownloadCriteria("URC_Research_Awards_criteria.pdf")}
  style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
>
  <Info className="info-icon" style={{ marginRight: "5px" }} />
  More Details
</span>
                  <div className="download-group">
                    <label>Application Template: </label>
                     <button
              className="download-btn"
              onClick={() => handleDownload("URC_Research_Awards.pdf")}
            >
              Download
            </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="award-item left">
              <h3 className="award-title">Recognition Awards</h3>
              <div className="award-box">
                <Award className="award-icon" />
                <p>Celebrates researchers who secured significant national or international grants, weighted by funding amount, prestige, and role (PI/Co-I).</p>
                <div className="award-actions">
                  <span
  className="more-details"
  onClick={() => handleDownloadCriteria("Recognition_Awards_criteria.pdf")}
  style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
>
  <Info className="info-icon" style={{ marginRight: "5px" }} />
  More Details
</span>
                  <div className="download-group">
                    <label>Application Template: </label>
                     <button
              className="download-btn"
              onClick={() => handleDownload("Recognition_Awards.pdf")}
            >
              Download
            </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="award-item right">
              <h3 className="award-title">Prof. Lakshman Samaranayake Awards</h3>
              <div className="award-box">
                <Award className="award-icon" />
                <p>Awards top-tier researchers with international recognition, evaluated by publications, grants, h-index, citations, and impactful work (minimum 70 marks required).</p>
                <div className="award-actions">
                    <span
  className="more-details"
  onClick={() => handleDownloadCriteria("Prof._Lakshman_Samaranayke_Awards_criteria.pdf")}
  style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
>
  <Info className="info-icon" style={{ marginRight: "5px" }} />
  More Details
</span>
                  <div className="download-group">
                    <label>Application Template: </label>
                     <button
              className="download-btn"
              onClick={() => handleDownload("Prof._Lakshman_Samaranayake_Awards.pdf")}
            >
              Download
            </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="award-item left">
              <h3 className="award-title">Research Publication Facilitation Fund (APC)</h3>
              <div className="award-box">
                <Award className="award-icon" />
                <p> Provides financial support (up to USD 1500/year) to permanent staff for publishing in high-impact journals or the Ceylon Journal of Science.</p>
                <div className="award-actions">
                   <span
  className="more-details"
  onClick={() => handleDownloadCriteria("Research_Publication_Facilitation_Fund_(APC)_criteria.pdf")}
  style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
>
  <Info className="info-icon" style={{ marginRight: "5px" }} />
  More Details
</span>
                  <div className="download-group">
                    <label>Application Template: </label>
                     <button
              className="download-btn"
              onClick={() => handleDownload("Research_Publication_Facilitation_Fund_(APC).pdf")}
            >
              Download
            </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* How It Works Section */}
        <section className="how-it-works">
          <h2 className="section-title">How It Works</h2>
          <p className="section-subtitle">
            Applying for awards is simple and straightforward. Follow these steps to get started.
          </p>
          <div className="steps-grid">
            <div className="step-item">
              <div className="step-number">1</div>
              <FileText className="step-icon" />
              <h3>Download Template</h3>
              <p>Access the appropriate application template for your chosen award after login to our platform.</p>
            </div>
            <div className="step-item">
              <div className="step-number">2</div>
              <FileText className="step-icon" />
              <h3>Complete Application</h3>
              <p>Fill out the form with your details and attach required documents as a single PDF.</p>
            </div>
            <div className="step-item">
              <div className="step-number">3</div>
              <CheckCircle className="step-icon" />
              <h3>Submit & Track</h3>
              <p>Upload your application through our portal and track its status until the results are announced.</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default HomePage;